import { render, staticRenderFns } from "./complianceGraph.vue?vue&type=template&id=63396963"
import script from "./complianceGraph.vue?vue&type=script&lang=js"
export * from "./complianceGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63396963')) {
      api.createRecord('63396963', component.options)
    } else {
      api.reload('63396963', component.options)
    }
    module.hot.accept("./complianceGraph.vue?vue&type=template&id=63396963", function () {
      api.rerender('63396963', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/pca/complianceGraph.vue"
export default component.exports